/**
 * @desc create
 */
const URL = "/rantion-wms";
import http, { updateResponse } from "@/http";
export function request(body: defs.wms.LogisticsReverseLabelRequestDto, options?: any) {
  return updateResponse(
    http(URL + `/logisticsReverse/create`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
